module.exports = __webpack_public_path__ + "static/media/check.f1e65aaf.svg";